import Message from "@components/Message";

import { useVerificationResponse } from "@/lib/state/contextHooks";

const FooterText = () => {
  const verificationResponse = useVerificationResponse();
  const footerClassName = "sid-footer__text";
  return (
    <div className={footerClassName}>
      {/**
       * By passing currentStep into the Translation, we enable the potential of
       * step specific overrides e.g. footerText_docUpload, while also only needing to
       * maintain a single default message.
       */}
      <Message id="footerText" context={verificationResponse.currentStep} />
    </div>
  );
};

export { FooterText };
